module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9SuF4"))).then(() => parcelRequire('cvs7o'));